import { get } from "../../../utils";
export var apiTaskDetail = function apiTaskDetail(options) {
  var showLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return get({
    url: '/flow/core/query/orderDetail',
    query: options,
    loading: showLoading,
    errorTip: false
  });
};

/**
 * 流程详情
 *
 * FlowOrderDetailVo
 */

/**
 * com.micun.flow.core.service.bean.vo.UserVo
 *
 * UserVo
 *
 * 流程发起人
 *
 * com.micun.sso.client.model.vo.UserDetail
 *
 * 转交接收人
 *
 * 操作人
 */

/**
 * 操作按钮
 *
 * FlowOperateButtonVo
 */

/**
 * FlowLink
 */

/**
 * LinkPath
 */

/**
 * MiniProgram
 */

/**
 * Web
 */

/**
 * com.micun.flow.definition.api.bean.inner.link.FlowLinkParameter
 *
 * FlowLinkParameter
 */

/**
 * 来源
 *
 * Source
 */

/**
 * 表单字段
 *
 * SelectedField
 */

/**
 * Map«Object»
 */

/**
 * com.micun.flow.core.biz.bean.vo.SubFlowOrderSummaryVo
 *
 * SubFlowOrderSummaryVo
 */

/**
 * FlowOrderSimpleVo
 */

/**
 * TaskOrderSimpleVo
 */

/**
 * TaskOrderDetailVo
 */

/**
 * TaskOrderOpLogVo
 */

/**
 * FormDiffSummaryVo
 */

/**
 * com.micun.flow.core.biz.bean.vo.diff.FormDiffSummaryItem
 *
 * FormDiffSummaryItem
 */

/**
 * com.micun.form.client.model.FieldValue
 *
 * FieldValue
 */